import { Component, OnInit } from '@angular/core';
import { GDPRManager } from './../../managers/gdpr.manager';
import { Router, ActivatedRoute } from '@angular/router';
import { TEXT } from './../../app.const';
import { SharedService } from './../../shared';

@Component({
  selector: 'app-policy',
  templateUrl: './policy.component.html',
  styleUrls: ['./policy.component.scss', '../../app.component.scss']
})
export class PolicyComponent implements OnInit {
  public TEXT = TEXT;
  public heading: string;
  constructor(private mgr: GDPRManager, public sharedService: SharedService, public router: ActivatedRoute, public route: Router) { }

  ngOnInit() {
  }


}



// WEBPACK FOOTER //
// ./src/app/containers/policy/policy.component.ts